
import { Component, Vue } from "vue-property-decorator";
import BaseTable from "@/components/BaseTable/index.vue";
import {
  ProductNumberType,
  saveNumberType,
  searchProductNumberType,
} from "@/api/product-number";
import { Form } from "element-ui";

@Component({
  name: "NumberTypeList",
  components: { BaseTable },
})
export default class extends Vue {
  private formDate: ProductNumberType = {} as ProductNumberType;
  private dialogVisible = false;
  private tableData: ProductNumberType[] = [];
  private rules = {
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    weight: [
      { required: true, message: "请输入权重", trigger: "blur" },
      {
        validator: (rule, value, callback) => {
          if (!value) {
            callback(new Error("请输入权重"));
          }
          if (value < 0) {
            callback(new Error("权重不能小于0"));
          }
          return callback();
        },
        trigger: "blur",
      },
    ],
  };

  private tableCol = [
    { label: "名称", prop: "name", key: "name", width: "100" },
    { label: "编码", prop: "code", key: "code", width: "100" },
    {
      label: "描述",
      prop: "description",
      key: "description",
      width: "100",
    },
    {
      label: "优先级权重",
      prop: "weight",
      key: "weight",
      width: "100",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      width: "100",
      options: [
        {
          name: "编辑",
          click: "editRow",
          render: () => {
            return true;
          },
        },
      ],
    },
  ];

  private created() {
    this.getList();
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    await searchProductNumberType().then((res) => {
      this.tableData = res as any;
    });
    this.loading = false;
  }

  private addNumberType() {
    this.showEdit = false;
    this.formDate = {} as ProductNumberType;
    this.dialogVisible = true;
  }

  private closeTab() {
    this.dialogVisible = false;
    this.formDate = {} as ProductNumberType;
  }

  private async saveType() {
    let dataForm = this.$refs["formDate"] as Form;
    dataForm.validate(async (valid) => {
      if (valid) {
        await saveNumberType(this.formDate).then(() => {
          this.formDate = {} as ProductNumberType;
          this.dialogVisible = false;
          this.getList();
        });
        return true;
      }
      return false;
    });
  }

  private showEdit = false;
  private editRow(scoop) {
    this.formDate = { ...scoop.row };
    this.showEdit = true;
    this.dialogVisible = true;
  }
}
